module.exports = __webpack_public_path__ + "static/media/corporat-culture.bedd950e.png";